import { memo } from "react";

import { Image } from "@components/Image";
import { Text } from "@components/Text";
import { type BrandValueProp } from "@root/tablescape/state";
import { formatFullyQualifiedUrl } from "@root/tablescape/utilities";
import { tw } from "classnames";

const styles = {
  valuePropImageWrapper: tw("inline-block", "w-12", "h-12"),
  valuePropPlainText: tw("pb-2", "pt-0", "text-center", "text-primary"),
  valuePropLink: tw("text-primary", "no-underline", "hover:underline"),
};

const BrandValuePropItemBase = ({
  valueProp,
}: {
  valueProp: BrandValueProp;
}) => {
  return (
    <>
      <div className={styles.valuePropImageWrapper}>
        <Image
          alt={valueProp.image.altText}
          height={48}
          src={formatFullyQualifiedUrl(valueProp.image.url)}
          width={48}
        />
      </div>
      <Text as="caption" className={tw(styles.valuePropPlainText)}>
        {valueProp.text}
      </Text>
    </>
  );
};

export const BrandValuePropItem = memo(BrandValuePropItemBase);
